import { MessageDescriptor, defineMessage } from 'react-intl'

export const DOMAIN_MIN_LENGTH = 4

export enum Paths {
  Create = 'CREATE',
  Join = 'JOIN',
  Accept = 'ACCEPT',
  Select = 'SELECT',
}

export type PathProps = {
  id: string
  metaTitle: MessageDescriptor
  metaDescription: MessageDescriptor
  canonicalUrl: string
}

export const getPaths = (
  superEnabled: boolean
): { [key in Paths]: PathProps } => ({
  [Paths.Create]: {
    id: 'create',
    metaTitle: defineMessage({
      id: 'boarding.createTeam.metaTitle',
      defaultMessage: 'Get started | {product}',
    }),
    metaDescription: defineMessage({
      id: 'boarding.createTeam.metaDescription',
      defaultMessage:
        'Try {product} for free with your teammates. All it takes is an email address to get started',
    }),
    canonicalUrl: superEnabled
      ? 'https://super.work/organization/super/create'
      : 'https://slite.com/organization/create',
  },
  // Path JOIN and ACCEPT display the same url
  [Paths.Join]: {
    id: 'join',
    metaTitle: defineMessage({
      id: 'boarding.joinTeam.metaTitle',
      defaultMessage: 'Join your team workspace | {product}',
    }),
    metaDescription: defineMessage({
      id: 'boarding.joinTeam.metaDescription',
      defaultMessage:
        'Join your team workspace to collaborate with your teammates. All it takes is an email address to get started.',
    }),
    canonicalUrl: superEnabled
      ? 'https://super.work/organization/super/join'
      : 'https://slite.com/organization/join',
  },
  [Paths.Accept]: {
    id: 'accept',
    metaTitle: defineMessage({
      id: 'boarding.joinTeam.metaTitle',
      defaultMessage: 'Join your team workspace | {product}',
    }),
    metaDescription: defineMessage({
      id: 'boarding.joinTeam.metaDescription',
      defaultMessage:
        'Join your team workspace to collaborate with your teammates. All it takes is an email address to get started.',
    }),
    canonicalUrl: superEnabled
      ? 'https://super.work/organization/super/join'
      : 'https://slite.com/organization/join',
  },
  [Paths.Select]: {
    id: 'select',
    metaTitle: defineMessage({
      id: 'boarding.signIn.metaTitle',
      defaultMessage: 'Sign in to your workspace | {product}',
    }),
    metaDescription: defineMessage({
      id: 'boarding.signIn.metaDescription',
      defaultMessage:
        'Use your email to find the workspaces you can sign in to, or use your workspace URL.',
    }),
    canonicalUrl: superEnabled
      ? 'https://super.work/organization/super/select'
      : 'https://slite.com/organization/select',
  },
})
